(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../components/Button"), require("@square/maker-icons/Plus"), require("@square/maker-icons/Minus"));
	else if(typeof define === 'function' && define.amd)
		define(["../../components/Button", "@square/maker-icons/Plus", "@square/maker-icons/Minus"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../components/Button"), require("@square/maker-icons/Plus"), require("@square/maker-icons/Minus")) : factory(root["../../components/Button"], root["@square/maker-icons/Plus"], root["@square/maker-icons/Minus"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 